exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tab-content .tab-pane {\n    padding: 15px 0px;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/CRM/SMSServiceProvider.vue"],"names":[],"mappings":";AACA;IACI,kBAAkB;CACrB","file":"SMSServiceProvider.vue","sourcesContent":["\n.tab-content .tab-pane {\n    padding: 15px 0px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0666f9cc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/CRM/SMSServiceProvider.vue
// module id = BNfB
// module chunks = 2